import { useEffect, useState } from "react";
import api from "@/lib/api";
import { X, Plus } from "lucide-react";
import AnagraficaCliente from "@/components/AnagraficaCliente";

const nomeDi = (c) => (c.tipo_soggetto === "giuridica" && c.societa_ragione_sociale) || [c.nome, c.cognome].filter(Boolean).join(" ") || c.ragione_sociale || "—";

export function ClientiPicker({ tipo, label, ids, onChange, error, immobileId, soloCrm }) {
  const [lista, setLista] = useState([]);
  const [nuovo, setNuovo] = useState(false);
  const url = tipo === "venditore" ? "/proprietari" : "/acquirenti";
  const load = () => api.get(url).then((r) => setLista(r.data || [])).catch(() => setLista([]));
  useEffect(() => { load(); }, [url]); // eslint-disable-line
  const emit = (nuoviIds, extra = []) => {
    const all = [...lista, ...extra];
    onChange(nuoviIds, nuoviIds.map((i) => nomeDi(all.find((c) => c.id === i) || {})).join(", "));
  };
  const scelti = ids.map((i) => lista.find((c) => c.id === i)).filter(Boolean);
  return (
    <div data-field-error={error ? "true" : undefined} data-testid={`picker-${tipo}`}>
      <label className="block text-[11px] font-semibold uppercase tracking-wide text-[var(--muted)] mb-1.5">{label} *</label>
      <div className="flex flex-wrap gap-1.5 mb-1.5">
        {scelti.map((c) => (
          <span key={c.id} className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-[#FC82ED]/15 text-xs font-semibold">{nomeDi(c)}
            <button type="button" data-testid={`picker-${tipo}-rimuovi-${c.id}`} onClick={() => emit(ids.filter((x) => x !== c.id))}><X size={12} /></button></span>
        ))}
      </div>
      <div className="flex gap-2">
        <select data-testid={`picker-${tipo}-select`} value="" onChange={(e) => e.target.value && emit([...ids, e.target.value])}
          className={`flex-1 min-w-0 px-3 py-2.5 rounded-lg bg-white border text-sm ${error ? "border-red-500" : "border-[var(--border)]"}`}>
          <option value="">— Scegli dal CRM —</option>
          {lista.filter((c) => !ids.includes(c.id)).map((c) => <option key={c.id} value={c.id}>{nomeDi(c)}{c.telefono ? ` · ${c.telefono}` : ""}</option>)}
        </select>
        {!soloCrm && <button type="button" data-testid={`picker-${tipo}-nuovo`} onClick={() => setNuovo(true)} className="shrink-0 inline-flex items-center gap-1 px-3 py-2 rounded-lg border border-[var(--border)] bg-white text-xs font-semibold"><Plus size={13} /> Nuovo cliente</button>}
      </div>
      {error && <p className="mt-1 text-xs text-red-600 font-medium">{error}</p>}
      {soloCrm && <p className="mt-1 text-[11px] text-[var(--muted)]">Un acquirente nuovo va prima creato in Acquirenti (o dalla proposta).</p>}
      {nuovo && <AnagraficaCliente tipo={tipo} immobileId={immobileId} onClose={() => setNuovo(false)}
        onSaved={async (c) => { setNuovo(false); const r = await api.get(url).catch(() => ({ data: lista })); setLista(r.data || []); if (c?.id) onChange([...ids, c.id], [...ids, c.id].map((i) => nomeDi((r.data || []).find((x) => x.id === i) || c)).join(", ")); }} />}
    </div>
  );
}
